import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c010fb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { class: "mod_c_title watch_title" }
const _hoisted_3 = { class: "mod_c_tbody" }
const _hoisted_4 = { class: "mod_content" }
const _hoisted_5 = { class: "mod_add" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "mod_video" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mod_bottom" }
const _hoisted_11 = {
  key: 0,
  class: "switch"
}
const _hoisted_12 = { class: "img" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { style: {"min-width":"670px"} }
const _hoisted_15 = { class: "mod_title" }
const _hoisted_16 = { class: "mod_duration" }
const _hoisted_17 = { class: "del-options" }
const _hoisted_18 = { class: "del" }
const _hoisted_19 = { class: "mod_save" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://images.innocomn.com/c3a4f202109221415107169.gif" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "listBox" }
const _hoisted_24 = { class: "listTop" }
const _hoisted_25 = { class: "top_left" }
const _hoisted_26 = { style: {"width":"200px"} }
const _hoisted_27 = { style: {"color":"#00ccb0"} }
const _hoisted_28 = { class: "top_right" }
const _hoisted_29 = { class: "container_progress" }
const _hoisted_30 = {
  key: 0,
  style: {"height":"500px"}
}
const _hoisted_31 = {
  key: 1,
  style: {"height":"500px","text-align":"center","width":"100%","line-height":"400px"}
}
const _hoisted_32 = {
  key: 2,
  style: {"width":"100%","height":"480px","overflow-y":"auto"},
  class: "",
  "infinite-scroll-disabled": "false",
  "infinite-scroll-distance": "20"
}
const _hoisted_33 = { class: "listBottom" }
const _hoisted_34 = { class: "b_box" }
const _hoisted_35 = { class: "checkbox" }
const _hoisted_36 = ["onUpdate:modelValue", "onChange"]
const _hoisted_37 = { class: "b_left" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "b_right" }
const _hoisted_41 = { class: "created_time" }
const _hoisted_42 = {
  class: "loading",
  style: {"height":"20px","line-height":"50px","text-align":"center"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您添加的视频包含打点内容，是否添加到自定义菜单中？", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您添加的视频包含打点内容，自定义菜单数量已满，需要手动添加，是跳转到自定义菜单？", -1))

import { emptyDataSec } from '@/assets';
import { useRoute, useRouter } from 'vue-router';
import Crumb from '@/components/Crumb.vue';
import { Modal, Input, message, Progress, Select } from 'ant-design-vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { getToken, getHelperStatus } from '@/plugins/cookie';
import 'video.js/dist/video-js.css';
import { VueDraggableNext } from 'vue-draggable-next';
import http from '@/api/playback';
import { ref, computed, onUnmounted, nextTick, inject, onMounted } from 'vue';
import router from '@/router';
import { useStore } from 'vuex';
import SvgIcon from '@/components/SvgIcon.vue';
import CLoading from '@/components/CLoading.vue';
import CDelModal from '@/components/CDelModal.vue';
import { dragDrop } from '@/utils/format/dragDrop';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { useHomeStore } from '@/pinia/home';

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
  type?: string;
  size: number;
  preview?: string;
  originFileObj: never;
  // originFileObj: any;
}
//switch开关
// const checked = ref<boolean>(false);
interface livedata {
  cover_url: string;
  title: string;
  duration: string;
}
interface livedatas {
  cover_url: string;
  duration: string;
  id: number;
  code: number;
  title: string;
  created_at: string;
  resolution: string;
  check: boolean;
}
interface idnumber {
  id: number;
  video_url: string;
}
//防抖
interface idtype {
  id: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Notice',
  setup(__props) {

const aModal = Modal;
const aInputSearch = Input.Search;
const draggable = VueDraggableNext;
const aProgress = Progress;
const aSelect = Select;
const route = useRoute();
const resRouter = useRouter();
const token = getToken();
const studioId = router.currentRoute.value.params.studioId;

const showLoading = ref<boolean>(false);
const helperUrl = getHelperStatus();

const disabled = ref(false);

const visible = ref<boolean>(false);
// const playList = ref([]);
// const addPlayList = ref([]);
const playList = ref<livedata[]>([]);
const addPlayList = ref<livedatas[]>([]);
// const media = ref();
const videoRef = ref();
const videoPlayer = ref();
const player_data = ref({
  video_url: '',
  image_player_cover_url: '',
});

const homeStore = useHomeStore();
const loadVideojs: any = inject('loadVideojs');

onMounted(async () => {
  if (!homeStore.onVideojs) {
    await loadVideojs();
    homeStore.onVideojs = true;
  }
});
//m3u8格式
const Mplayer = (data: any) => {
  videoPlayer.value = new window.videojs(videoRef.value, {
    playbackRates: [0.5, 0.75, 1, 1.5, 2], //播放速度
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: true,
    techOrder: ['html5'], //html5模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    preload: true, //预加载
    autoplay: false, //是否自动播放
    poster: player_data.value.image_player_cover_url,
    loop: playList.value.length > 1 ? false : true,
  });
  try {
    videoPlayer.value.src({
      src: data.video_url,
    });
  } catch (err) {
    // console.log(err);
  }
};
//获取定制配置

const store = useStore();
const coverImg = ref<boolean>(false);
const stateUrl = computed(() => store.state.home.customData.video_url);
if (playList.value.length == 0) {
  coverImg.value = true;
} else {
  coverImg.value = false;
}
// setTimeout(() => {
//   Mplayer(player_data);
// });
//视频列表拖拽事件
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});
const moveEnd = () => {
  backSave(); //保存接口
};
const loadpage_size = ref(1); //第几页数据
const last_page = ref(0); //最后一页数据
const noMore = ref(false); //判断是否有更多数据
const addListVideo = () => {
  videochecked.value = [];
  addPlayList.value = [];
  loadpage_size.value = 1;
  visible.value = true;
  getCurrent(1, videoKeyword.value);
};
//点击整个模块勾选
const checked = (e: any) => {
  e.currentTarget.previousElementSibling.firstElementChild.click();
};
//勾选完视频确认按钮
const toCusDot = ref(false);
const handleOk = useDebounce((e: MouseEvent) => {
  let resData = addPlayList.value.filter((i: any) => videochecked.value.includes(i.id));
  let ids = ref<idnumber[]>([]);
  resData.forEach((item: any) => {
    ids.value.push(item.id);
  });
  if (resData.length > 0) {
    let data = {
      notice_ids: ids.value.join(','),
      status: switchstatus.value == true ? 1 : 0,
      studio_id: studioId,
      token: token,
      istop: 0,
      top_notice_id: '',
      is_del: delIndex.value ? 1 : 0,
    };
    http
      .set_live_studio_notice(data)
      .then(() => {
        visible.value = false;
        playList.value = resData;
        view_replay();
        http.isIncludeDot({ studio_id: studioId, video_ids: ids.value.join(',') }).then((res) => {
          if (res.data.data === 1) {
            cusDotVisible.value = true;
          } else if (res.data.data === 2) {
            toCusDot.value = true;
          }
        });
      })
      .catch((err) => message.error(err.data.error));
  }
});
const is_save_menu = ref(0);
const clickAddCustom = useDebounce((type: number) => {
  is_save_menu.value = type;
  http
    .is_save_dot_menu({ studio_id: studioId, is_save_menu: is_save_menu.value })
    .then((res) => {
      message.success(res.data.message);
      is_save_menu.value = 0;
    })
    .catch((err) => message.error(err.data.error));
  cusDotVisible.value = false;
});

const clickToCustom = (type: number) => {
  toCusDot.value = false;
  if (type) {
    resRouter.push({ name: 'CustomizeMenu' });
  }
};
// 删除
const delVisible = ref<boolean>(false);
const delIndex = ref();
const openDelModal = () => {
  delVisible.value = !delVisible.value;
  delIndex.value = '';
};
// 确定删除
const okDelModal = () => {
  playList.value.splice(delIndex.value, 1);
  delVisible.value = false;
  backSave();
};

const toDelete = (index: number) => {
  delVisible.value = true;
  delIndex.value = index;
};
const videoList = ref();
// let videoData = ref();
let switchstatus = ref<any>(false);
//视频回放的保存按钮
const shake = ref<boolean>(false);
const backSave = useDebounce((record?: any) => {
  let ids = ref<idnumber[]>([]);
  playList.value.forEach((item: any) => {
    ids.value.push(item.id);
    player_data.value.video_url = item.video_url;
  });
  let data = {
    notice_ids: ids.value.join(','),
    status: switchstatus.value == true ? 1 : 0,
    studio_id: studioId,
    token: token,
    istop: record ? 1 : 0,
    top_notice_id: record ? record.id : '',
    is_del: delIndex.value ? 1 : 0,
  };
  if (shake.value) {
    return;
  }
  shake.value = true;
  http
    .set_live_studio_notice(data)
    .then((res) => {
      shake.value = false;
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
        view_replay();
        delIndex.value = '';
        visible.value = false;
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
});
//选择视频添加到回放中
const videochecked = ref<idtype[]>([]); //选择视频放入数组
let loadpage_total = ref<any>(0); //视频总条数
const checkChange = (item: any) => {
  if (item.check) {
    videochecked.value.push(item.id);
  } else {
    const index = videochecked.value.indexOf(item.id);
    videochecked.value.splice(index, 1);
  }
};

const options = ref([
  {
    value: 0,
    label: '全部视频',
  },
  {
    value: 1,
    label: '打点视频',
  },
]);
const selectId = ref(0);
const changeSelect = () => {
  addPlayList.value = [];
  getCurrent(1, videoKeyword.value);
};
//获取视频列表
const getCurrent = (current: any, keywords: any) => {
  let data = {
    token: token,
    keywords: keywords,
    page: current,
    page_num: 10,
    dotting_status: selectId.value,
  };
  showLoading.value = true;
  http
    .getVideoList({ params: data })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        addPlayList.value.push(...res.data.data.data);
        addPlayList.value.forEach((i: any) => {
          if (videochecked.value.includes(i.id)) {
            i.check = true;
          } else {
            i.check = false;
          }
          return i;
        });
        loadpage_total.value = res.data.data.total;
        last_page.value = res.data.data.last_page;
      }
    })
    .catch((err) => {
      showLoading.value = false;
    });
};
//滚动加载数据
const getChildList = () => {
  if (loadpage_size.value >= last_page.value) {
    noMore.value = true;
  } else {
    noMore.value = false;
    loadpage_size.value++;
    getCurrent(loadpage_size.value, videoKeyword.value);
  }
};
//搜索视频关键字
const videoKeyword = ref();
const videoSearch = () => {
  addPlayList.value = [];
  getCurrent(1, videoKeyword.value);
};
//查看回放视频
const loading = ref(true);
const player_list = ref([]);
const view_replay = () => {
  disabled.value = true;
  loading.value = true;
  let data = {
    token: token,
    studio_id: studioId,
  };
  http
    .get_studio_notice_replay_video({ params: data })
    .then((res) => {
      if (res.data.code == 200) {
        player_data.value.image_player_cover_url = res.data.data.image_player_cover_url; //封面图
        cycleSw.value = res.data.data.notice.cycle_switch ? true : false;

        if (res.data.data.notice.list && res.data.data.notice.list.length > 0) {
          playList.value = res.data.data.notice.list;
          player_data.value.video_url = res.data.data.notice.list[0].video_url;
          // if(playList.value.length != 0){
          res.data.data.notice.status == 1 ? (switchstatus.value = true) : (switchstatus.value = false);
          // }
          nextTick(() => {
            Mplayer(playList.value[0]);
            changeEnden();
          });
        }
      }
    })
    .finally(() => {
      loading.value = false;
      disabled.value = false;
    });
};
view_replay();

const cycleSw = ref(false);
const cycleSwitch = () => {
  http
    .cycleSwitch({ studio_id: studioId, cycle_switch: cycleSw.value ? '1' : '0', type: '1' })
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

const videoIndex = ref(0);
const changeEnden = () => {
  videoPlayer.value.on('ended', () => {
    videoIndex.value++;
    if (videoIndex.value > playList.value.length - 1 && cycleSw.value) {
      videoIndex.value = 0;
    }
    setTimeout(() => {
      Mplayer(playList.value[videoIndex.value]);
    });
  });
};

onUnmounted(() => {
  if (videoPlayer.value) videoPlayer.value.dispose();
});
//上传视频
// const uploadVideo = (info: FileInfo) => {
//   videoList.value = info.file;
//   if (videoList.value.response && videoList.value.response.code == 200) {
//     videoData.value = videoList.value.response.data;
//     const Uploader = aliUpload();
//     // uploading.value = true;
//     Uploader.addFile(videoList.value.originFileObj, null, null, null);
//     Uploader.startUpload();
//   }
// };

// 打点
const cusDotVisible = ref(false);
// 初始化上传
const uploading = ref(false);
const percent = ref(0);
const aliUpload = () => {
  const uploader = new window.AliyunUpload.Vod({
    userId: '1303984639806000',
    onUploadstarted: (uploadInfo: any) => {
      if (uploadInfo.videoId !== undefined) {
        // 断点续传
        console.log('断点续传');
        let data = {
          video_id: uploadInfo.videoId,
        };
        http
          .refreshUploadVideo({ params: data })
          .then((res) => {
            console.log('断点续传then');
            let uploadAuth = res.data.data.UploadAuth;
            let uploadAddress = res.data.data.UploadAddress;
            let videoId = res.data.data.VideoId;
            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
          })
          .catch(() => {
            console.log('断点续传catch');
            uploading.value = false;
          });
      } else {
        //正常上传
        console.log('正常上传');
        let data = {
          title: videoList.value.name.split('.')[0],
          format: videoList.value.name.split('.')[1],
          type: 1,
          size: videoList.value.size,
        };
        http
          .createUploadVideo(data)
          .then((res) => {
            console.log('正常上传then');
            let uploadAuth = res.data.data.UploadAuth;
            let uploadAddress = res.data.data.UploadAddress;
            let videoId = res.data.data.VideoId;
            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
          })
          .catch(() => {
            console.log('正常上传catch');
            uploading.value = false;
          });
      }
    },
    // 文件上传成功
    onUploadSucceed: () => {
      getCurrent(1, videoKeyword.value);
      uploading.value = false;
    },
    //文件上传进度，单位：字节
    onUploadProgress: (uploadInfo: any, totalSize: any, progress: any) => {
      percent.value = parseInt(String(progress * 100));
    },
    //文件上传失败
    onUploadFailed: () => {
      message.info('文件上传失败');
    },
    // 上传凭证超时
    onUploadTokenExpired: () => {
      message.info('上传凭证超时');
    },
  });
  return uploader;
};

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_unref(route).meta?.title), 1),
        _createVNode(_component_a_switch, {
          style: {"margin-left":"20px"},
          onChange: _cache[0] || (_cache[0] = ($event: any) => (playList.value.length > 0 ? _unref(backSave)() : '')),
          checked: _unref(switchstatus),
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_isRef(switchstatus) ? (switchstatus).value = $event : switchstatus = $event))
        }, null, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (addListVideo()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加视频")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("video", {
                ref_key: "videoRef",
                ref: videoRef,
                id: "videojs-player",
                controls: "",
                class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
              }, null, 512)
            ], 512), [
              [_vShow, playList.value.length != 0]
            ]),
            (playList.value.length == 0 && player_data.value.image_player_cover_url != '')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: player_data.value.image_player_cover_url
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            (coverImg.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(stateUrl)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (playList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(SvgIcon, {
                    "icon-class": "loop_icon",
                    style: {"margin-right":"8px"}
                  }),
                  _createTextVNode("列表循环播放 "),
                  _createVNode(_component_a_switch, {
                    style: {"margin-left":"8px"},
                    onChange: cycleSwitch,
                    checked: cycleSw.value,
                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((cycleSw).value = $event))
                  }, null, 8, ["checked"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(draggable), _mergeProps({ list: playList.value }, dragOptions.value, {
              onChange: moveEnd,
              handle: ".mover",
              options: { animation: 500 },
              onDrop: _unref(dragDrop)
            }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item-box",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: item.cover_url,
                        alt: ""
                      }, null, 8, _hoisted_13)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(item.duration), 1)
                    ]),
                    _createElementVNode("span", _hoisted_17, [
                      _createElementVNode("p", null, [
                        _createVNode(SvgIcon, {
                          class: "mover",
                          "icon-class": "drag_icon"
                        })
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_18, [
                        _createVNode(SvgIcon, {
                          "icon-class": "video_top",
                          onClick: ($event: any) => (_unref(backSave)(item)),
                          style: {"margin-right":"15px"}
                        }, null, 8, ["onClick"]),
                        _createVNode(SvgIcon, {
                          onClick: ($event: any) => (toDelete(index)),
                          "icon-class": "del",
                          style: {"color":"#505d6f"}
                        }, null, 8, ["onClick"])
                      ], 512), [
                        [_vShow, playList.value.length > 1]
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 16, ["list", "onDrop"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_a_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(backSave)())),
              type: "primary",
              disabled: disabled.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createVNode(CDelModal, {
        visible: delVisible.value,
        centered: "",
        close: openDelModal,
        ok: okDelModal
      }, null, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: visible.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
        title: "添加视频",
        onOk: _unref(handleOk),
        width: "910px"
      }, {
        default: _withCtx(() => [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_unref(aSelect), {
                  value: selectId.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((selectId).value = $event)),
                  class: "polyglot_option",
                  options: options.value,
                  onChange: changeSelect
                }, null, 8, ["value", "options"]),
                _createVNode(_unref(aInputSearch), {
                  class: "mod_range_picker_search margin-b",
                  value: videoKeyword.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((videoKeyword).value = $event)),
                  placeholder: "请输入关键字",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (videoSearch()))
                }, {
                  enterButton: _withCtx(() => [
                    _createVNode(_unref(SearchOutlined))
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("span", _hoisted_26, [
                  _createTextVNode("视频数量："),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(loadpage_total)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_unref(helperUrl))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { path: `/media/videos/${_unref(studioId)}` },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, null, {
                          default: _withCtx(() => [
                            _createTextVNode("去上传")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { path: `/media` },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, null, {
                          default: _withCtx(() => [
                            _createTextVNode("去上传")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_29, [
              _createVNode(_unref(aProgress), {
                percent: percent.value,
                status: "active",
                format: (percent) => `上传中：${percent}%`
              }, null, 8, ["percent", "format"])
            ], 512), [
              [_vShow, uploading.value]
            ]),
            (showLoading.value && addPlayList.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(CLoading)
                ]))
              : (addPlayList.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_a_empty, {
                      class: "empty_wrap",
                      image: _unref(emptyDataSec),
                      description: "页面暂无数据信息~"
                    }, null, 8, ["image"])
                  ]))
                : _createCommentVNode("", true),
            (addPlayList.value.length != 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addPlayList.value, (i, j) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item-box",
                        key: j
                      }, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((i.check) = $event),
                              onChange: ($event: any) => (checkChange(i))
                            }, null, 40, _hoisted_36), [
                              [_vModelCheckbox, i.check]
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "b_content",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (checked($event)))
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("img", {
                                src: i.cover_url
                              }, null, 8, _hoisted_38),
                              _createElementVNode("span", null, _toDisplayString(i.duration), 1),
                              (i.code == 207)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "视频转码失败！"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("h2", null, _toDisplayString(i.title), 1),
                              _createElementVNode("p", _hoisted_41, [
                                _createTextVNode(" 上传时间："),
                                _createElementVNode("span", null, _toDisplayString(i.created_at), 1)
                              ]),
                              _createElementVNode("p", null, "分辨率：" + _toDisplayString(i.resolution), 1)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    (noMore.value && addPlayList.value.length > 9)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_43, "没有更多了"))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_directive_infinite_scroll, getChildList]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk"]),
      _createVNode(_unref(aModal), {
        visible: cusDotVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((cusDotVisible).value = $event)),
        title: "提示",
        centered: "",
        onOk: _cache[11] || (_cache[11] = ($event: any) => (_unref(clickAddCustom)(1))),
        onCancel: _cache[12] || (_cache[12] = ($event: any) => (_unref(clickAddCustom)(0)))
      }, {
        default: _withCtx(() => [
          _hoisted_44
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: toCusDot.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((toCusDot).value = $event)),
        title: "提示",
        centered: "",
        onOk: _cache[14] || (_cache[14] = ($event: any) => (clickToCustom(1))),
        onCancel: _cache[15] || (_cache[15] = ($event: any) => (clickToCustom(0)))
      }, {
        default: _withCtx(() => [
          _hoisted_45
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})